import { render, staticRenderFns } from "./VoiceBrowserSearch.vue?vue&type=template&id=47fe2ae6&scoped=true&"
import script from "./VoiceBrowserSearch.vue?vue&type=script&lang=js&"
export * from "./VoiceBrowserSearch.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=47fe2ae6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fe2ae6",
  null
  
)

export default component.exports